import { Button } from "@/components/ui/button"
import { CustomerAddress, CustomerAddressType } from "@/api/customers"
import CustomerAddressForm from "./customer-address.form"
import { Checkbox } from "@/components/ui/checkbox"

interface CustomerAddressesProps {
  addresses: CustomerAddress[];
  onChange: (addresses: CustomerAddress[]) => void;
}

const createEmptyAddress = (type: CustomerAddressType) => ({
  type,
  countryId: "",
  stateId: undefined,
  address: "",
  addressExtra: "",
  city: "",
  postalCode: "",
})

export default function CustomerAddresses({
  addresses,
  onChange,
}: CustomerAddressesProps) {
  const onSameAddressChange = (checked: boolean) => {
    if (checked) {
      onChange([addresses[0]])
    } else {
      onChange([addresses[0], createEmptyAddress(CustomerAddressType.BILLING)])
    }
  }

  if (addresses.length === 0) {
    return (
      <Button
        type="button"
        variant="outline"
        onClick={() =>
          onChange([createEmptyAddress(CustomerAddressType.SHIPPING)])
        }
      >
        Add address
      </Button>
    )
  }
  return (
    <>
      <CustomerAddressForm index={0} />
      <div className="flex items-center space-x-2 pt-2">
        <Checkbox
          id="sameAddress"
          checked={addresses.length === 1}
          onCheckedChange={(checked: boolean) => onSameAddressChange(checked)}
        />
        <label
          htmlFor="terms"
          className="text-sm text-gray-300 font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          Billing details same as shipping details
        </label>
      </div>
      {addresses.length === 2 && (
        <>
          <h4 className="text-sm font-semibold">Customer address</h4>
          <CustomerAddressForm index={1} />
        </>
      )}
    </>
  )
}
